//https://medium.com/@bigcatplichta/javascript-use-bind-to-dynamically-add-and-remove-event-listeners-d6b443877a73

export default function searchClassInit(coreHandlerInstance, paramInstance) {
  const coreHandler = coreHandlerInstance;
  const unionClassName = ".js__data-box";
  const targetClassName = ".js__search-item";
  const tabClassName = ".js__tabmenu";
  const outputArea = document.getElementById("js__select-list");
  const outputAreaBody = document.getElementById("js__select-list-body");
  const resetButton = document.getElementById("js__select-reset-btn");
  const paramHandler = paramInstance;

  class SearchClass {
    static instanceList = [];
    static firstSelect;
    static selectList = [];
    static errorData = {
      "AndSearch": false,
      "PropertyId": 30260,
      "Text": "errorText",
      "Type": "text",
    };

    static init = () => {
      SearchClass.instanceList = [...document.querySelectorAll(targetClassName)].map(v => {
        return new SearchClass(v);
      });
      SearchClass.resetInit();
    };
    static lock = () => {
      SearchClass.instanceList.map(v => {
        v.ele.disable = true;
      });
    };

    static getInstanceByItemId = (itemId) => {
      return SearchClass.instanceList.find(instance => { 
        return instance.itemId == itemId && instance.mode === "case";
      });
    }

    static paramLoad = (searchList) => {
      let loadList = [];

      for (var prop in searchList) {
        let filterList = SearchClass.instanceList.filter(v => {
          let instanceObj = v;
          let instanceItem = v.data;
          let paramItem = searchList[prop];

          if (paramItem.PropertyId === "ex_case") {
            return (paramItem.PropertyId == instanceObj.propertyId && paramItem.ItemIds.includes(instanceObj.itemId));
          } else {

            return (paramItem.PropertyId == instanceItem.PropertyId && paramItem.ItemIds.includes(instanceItem.ItemId));
          }

        });

        if (filterList) {
          loadList = loadList.concat(filterList);
        }
      }

      if (loadList.length > 0) {
        loadList.forEach(v => {
          v.addFilterEvent(true);
        });
      }
    }

    static accordionEvent = () => {
      
      const selectList = SearchClass.instanceList.filter(instance => instance.selected  === true && instance.mode === "case" );
      if( selectList.length > 0 ){
        selectList.forEach( instance => {
          const accordionList = coreHandler.accordionClass.getRootAccordionInstances(instance.ele);
          coreHandler.accordionClass.performActionOnAccordions( accordionList , 'menuOpen' );
        });
      }

    }

    static rebuild = (json) => {
      let resultRangeList = Object.entries(json.range).filter(v => v[1].PropertyType == "List");

      const data = coreHandler.recentEvent;
      const lockPropertyId = (data !== null && data.hasOwnProperty('PropertyId')) ? data.PropertyId : false;

      resultRangeList.forEach(result => {

        let count = 0;
        let resultValues = result["1"].Values;

        const samePropList = SearchClass.instanceList.filter(v => {
          return v.data.PropertyId == result[0];
        });



        if (samePropList.length > 0) {

          samePropList.forEach(target => {

            if (target.data.PropertyId == lockPropertyId && target.data.AndSearch === false) return;

            let findItem = resultValues.find(el => el.Id == target.data.ItemId);
            if (findItem) {
              count = findItem.EntryCount;
            } else {
              count = 0;
            }
            target.ele.lastChild.innerHTML = "(" + count + ")";
            target.ele.lastElementChild.innerHTML = "(" + count + ")";
            target.ele.setAttribute('data-entry-count', count);

            if (target.selected == false && count == 0) {
              target.ele.style.opacity = "0.5";
              target.input.disabled = true;
              target.removeListener();
            } else {

              target.ele.style.opacity = "1";
              target.input.disabled = false;
              target.addListener();
            }
          });
        }

      });

    };
    static resetInit = () => {
      return resetButton.addEventListener("click", () => {
        coreHandler.allReset();
      });
    };

    static allReset = () => {
      SearchClass.instanceList.map(v => {
        v.ele.classList.remove("is-selected");
        v.ele.querySelector("input").checked = false;
        v.selected = false;
      });
      while (outputAreaBody.firstChild) {
        outputAreaBody.removeChild(outputAreaBody.firstChild);
      }
      outputArea.style.display = "none";
    }


    static getInstanceByPropertyAndItem = (propertyId, itemId) => {
      return SearchClass.instanceList.find(instance => {
        return instance.propertyId == propertyId && instance.itemId == itemId
      });
    };

    static getCheckedItems() {
      return SearchClass.instanceList
        .filter(item => item.selected)
        .map(item => ({
          propertyId: item.propertyId,
          itemId: item.itemId
        }));
    }

    static getSuggestDiffEvent( diffData ){

      if( diffData === null || diffData === undefined || diffData === false ) return;
      let diffDataList = SearchClass.modifySuggestDiffdataToSearchClassData( diffData );

      if( diffDataList.addList.length > 0 ) {
        diffDataList.addList.forEach( instance => instance.multipleSelectAdd(  instance, paramHandler ) );
      }
      if( diffDataList.removeList.length > 0 ) {
        diffDataList.removeList.forEach( instance => instance.multipleSelectRemove(  instance, paramHandler ) );
      }

      coreHandler.sendClickEvent();
      SearchClass.accordionEvent();

    }

    static modifySuggestDiffdataToSearchClassData( diffData ){
      let addList = diffData.add;
      let removeList = diffData.remove;
      let diffList = { addList: [], removeList:[] };

      if( addList.length > 0){
        diffList.addList = addList.map( itemId => SearchClass.getInstanceByItemId(itemId) );
      }
      if( removeList.length > 0){
        diffList.removeList = removeList.map( itemId => SearchClass.getInstanceByItemId(itemId) );
      }

      return diffList;

    }

    static execSendSelectEventByCaseSearchComponent(caseSearchComponentInstanceList) {

      // console.log( "caseSearchComponentInstanceList" , caseSearchComponentInstanceList);

      let componentInstanceList = caseSearchComponentInstanceList;
      let searchList = SearchClass.instanceList.filter(instance => instance.mode === "case");

      // console.log("componentInstanceList", componentInstanceList);
      let matchSearchList = searchList.filter(instance => {
        return componentInstanceList.some(component => component.itemId === instance.itemId);
      });
      // console.log("matchSearchList", matchSearchList);
      if (matchSearchList.length < 1) {
        coreHandler.setCaseErrorFlag();
      } else {
        matchSearchList.map(v => v.selectEvent());
      }

    }


    static execSendRemoveEventByCaseSearchComponent(caseSearchComponentInstanceList) {

      let componentInstanceList = caseSearchComponentInstanceList;
      let searchList = SearchClass.instanceList.filter(instance => instance.mode === "case");

      // console.log("componentInstanceList", componentInstanceList);
      let matchSearchList = searchList.filter(instance => {
        return componentInstanceList.some(component => component.itemId === instance.itemId);
      });
      // console.log("matchSearchList", matchSearchList);
      if (matchSearchList.length < 1) {} else {
        matchSearchList.map(v => v.removeEvent());
      }
      coreHandler.removeCaseErrorFlag();


    }
    static sendErrorEvent() {
      coreHandler.setFilter(SearchClass.errorData, null, this);
    }

    constructor(ele) {
      this.instanceType = "SearchClass";
      this.ele = ele;
      this.union = this.ele.closest(unionClassName);
      this.propertyId = this.union.getAttribute('data-property-id') || null;
      this.groupId = this.ele.getAttribute('data-group-id') || null;
      this.postId = this.ele.getAttribute('data-post') || null;
      this.errorFlag = (() => {
        if (this.groupId === null || typeof this.groupId !== "string") return false;
        const regex = /xxx/;
        return regex.test(this.groupId);
      })();
      this.itemId = this.ele.getAttribute('data-id') || null;
      this.taxChain = this.ele.getAttribute('data-tax-chain') || null;
      this.multipleSelector = this.ele.getAttribute('data-multiple-selector') || null;
      this.multipleParent = this.ele.getAttribute('data-multiple-parent') || null;
      this.dataType = this.union.getAttribute('data-type');
      this.value = this.ele.getAttribute("data-value");
      this.mode = this.ele.closest(tabClassName) ? this.ele.closest(tabClassName).getAttribute("data-mode") : null;
      this.suggestList = this.ele.getAttribute("data-suggest-list") || null;
      this.data = {}; // ここで初期化

      if (this.union.getAttribute('data-type') === null) {
        throw new Error('data-type 属性がありません。必須です。');
      }

      let dataType = this.union.getAttribute('data-type');
      if (dataType === "List") {
        this.data = {
          "Type": dataType ? dataType.toLowerCase() : null,
          "PropertyId": this.union.getAttribute('data-property-id') || null,
          "ItemId": this.ele.getAttribute('data-id') || null,
          "EntryId": this.ele.getAttribute('data-entry-count') || null,
        };
      } else if (dataType === "text") {
        if (this.groupId !== null) {
          let textPipe = this.groupId.replace(/,/g, "|");
          this.data = {
            "Type": "text",
            "PropertyId": 30260,
            "Text": textPipe
          };
        }
      }

      this.andSearch = this.union.getAttribute("data-and-search");
      if (this.data === null) console.log("ele", this.union);
      if (this.andSearch) {
        this.data.AndSearch = true;
      } else {
        this.data.AndSearch = false;
      }
      this.labelText = this.ele.firstElementChild.textContent ? this.ele.firstElementChild.textContent : this.ele.textContent || this.ele.parentNode.textContent || null;
      this.selected = this.ele.getAttribute("data-selected") || false;
      this.input = this.ele.querySelector('input');

      this.clickHandler = this.clickEvent.bind(this);
      this.input.addEventListener("click", this.clickHandler, true);


      if (typeof WOVN !== 'undefined') {
        window.addEventListener('wovnLangChanged', (evt) => {
          var newLang = WOVN.io.getCurrentLang().code;
          if (newLang !== 'ja') {
            this.modifyTextSearchValue();
          }
        });
      }

    }


    modifyTextSearchValue = () => {
      const label = this.ele.querySelector("label");
      if (label === undefined) return false;
      const newValue = label.textContent;
      this.ele.setAttribute("data-value", newValue);
      this.labelText = newValue;
    }



    clickEvent = () => {

      if (this.multipleSelector === null) {
        if (!this.ele.classList.contains('is-selected')) {
          paramHandler.add(this);
          this.addFilterEvent(true);
          this.selected = true;

        
          // let accordion = coreHandler.accordionClass.searchAccordion(this.ele);
          // let accordionList = coreHandler.accordionClass.getRootAccordionInstances(this.ele);
          // coreHandler.accordionClass.performActionOnAccordions( accordionList , 'menuOpen' );
          // accordion.menuOpen();

        } else {
          paramHandler.remove(this);
          this.removeFilterEvent(true);
          this.selected = false;

        }

        // let checkedItems = SearchClass.getCheckedItems();        
        // coreHandler.suggestClass.syncSelectedItems(checkedItems);
        
        coreHandler.setRecentEvent(this);
      } else {
        const dataBox = this.ele.closest(".js__data-box");
        if (dataBox) {
          // const targetInstanceNum = dataBox.getAttribute("data-box-num");
          // const instance = coreHandler.accordionClass.selectInstance(targetInstanceNum);
          // instance.menuOpen();

          
          let accordion = coreHandler.accordionClass.searchAccordion(this.ele);
          let accordionList = coreHandler.accordionClass.getRootAccordionInstances(this.ele);
          coreHandler.accordionClass.performActionOnAccordions( accordionList , 'menuOpen' );
          // accordion.menuOpen();
          
        }
        let targetList = SearchClass.instanceList.filter(v => {
          return v.multipleParent === this.multipleSelector;
        });

        if (targetList.length > 0) {
          if (this.ele.classList.contains("is-selected")) {
            targetList.map(v => this.multipleSelectRemove(v, paramHandler));

            this.ele.classList.remove("is-selected");
            this.ele.querySelector("input").checked = false;
            this.selected = false;
            paramHandler.remove(this);
          } else {
            targetList.map(v => this.multipleSelectAdd(v, paramHandler));
            this.ele.classList.add("is-selected");
            this.ele.style.opacity = "1";
            this.selected = true;
            this.input.checked = true;
            paramHandler.add(this);
          }
        }

        // let checkedItems = SearchClass.getCheckedItems();
        // coreHandler.suggestClass.syncSelectedItems(checkedItems);

      }
      coreHandler.sendClickEvent();
    };

    multipleAddEvent = () => {
      const dataBox = this.ele.closest(".js__data-box");
      if (dataBox) {
        const targetInstanceNum = dataBox.getAttribute("data-box-num");
        const instance = coreHandler.accordionClass.selectInstance(targetInstanceNum);
        instance.menuOpen();
      }
      let targetList = SearchClass.instanceList.filter(v => {
        return v.multipleParent === this.multipleSelector;
      });


    }


    multipleSelectAdd = (instance, paramHandler) => {
      if (!instance.ele.classList.contains("is-selected")) {
        paramHandler.add(instance);
        instance.addFilterEvent(true);
      }
    }
    multipleSelectRemove = (instance, paramHandler) => {
      if (instance.ele.classList.contains("is-selected")) {
        paramHandler.remove(instance);
        instance.removeFilterEvent();
        instance.removeLabel();
      }
    }

    setErrorEvent = () => {
      coreHandler.setFilter(this.errorData, null, this);
    }

    removeErrorEvet = () => {
      coreHandler.removeFilter(this.errorData, false);
    }

    addFilterEvent = (selectFlag) => {
      if (this.selected === true) return false;
      this.addSelectList();
      this.ele.classList.add("is-selected");
      this.ele.style.opacity = "1";
      this.selected = true;
      if (selectFlag) {
        this.input.checked = true;
      }
      coreHandler.setFilter(this.data, null, this);

      if (this.errorFlag) {
        coreHandler.addErrorPostList(this);
      }
    }
    removeFilterEvent = () => {
      let multipleParentSelector = SearchClass.instanceList.filter(v => {

        if (v.multipleSelector == null || this.multipleParent == null) return false;
        return v.multipleSelector === this.multipleParent;

      });

      if (multipleParentSelector.length > 0) {
        multipleParentSelector.forEach(v => {
          v.ele.classList.remove("is-selected");
          v.ele.querySelector("input").checked = false;
          v.selected = false;
        });
      }
      this.ele.classList.remove("is-selected");
      this.ele.querySelector("input").checked = false;
      this.selected = false;
      this.removeLabel();

      paramHandler.remove(this.data);
      coreHandler.removeFilter(this.data, false);
      if (this.errorFlag) {
        coreHandler.removeErrorPostList(this);
      }
    }
    removeLabel = (option) => {
      let labelList = outputAreaBody.querySelectorAll(".js__select-label");

      let removeItemSearch = [...labelList].filter(v => {
        return v.getAttribute("data-property-id") == this.propertyId && v.getAttribute("data-item-id") == this.itemId;
      });

      if (removeItemSearch.length > 0) {
        removeItemSearch[0].removeEventListener("click", this.clickEvent, true);

        outputAreaBody.removeChild(removeItemSearch[0]);
      }

      labelList = outputArea.querySelectorAll(".js__select-label");

      if (labelList.length < 1) {
        outputArea.style.display = "none";
      }
    }
    addSelectList = () => {

      if (this.data.Type != "list" && this.data.Type != "text") return false;

      const newButton = document.createElement("button");
      newButton.className = "p-label js__select-label";
      newButton.setAttribute('data-property-id', this.propertyId);
      newButton.setAttribute('data-item-id', this.itemId);
      newButton.setAttribute('wovn-wait', '');

      let newSpan = document.createElement("span");
      newSpan.innerHTML = "<span class=\"material-icons-outlined p-material-icon\">close</span> " + "<span>" + this.labelText + "</span>";


      newButton.appendChild(newSpan);
      outputAreaBody.appendChild(newButton);
      outputArea.style.display = "flex";

      newButton.addEventListener("click", () => {
        this.clickEvent();
      }, true);

    }
    addListener = () => {
      this.input.addEventListener("click", this.clickHandler, true);
    }
    removeListener = () => {
      this.ele.children[0].removeEventListener("click", this.clickHandler, true);
    };

    selectEvent = () => {

      if (this.multipleSelector !== null) {
        const dataBox = this.ele.closest(".js__data-box");
        if (dataBox) {
          const targetInstanceNum = dataBox.getAttribute("data-box-num");
          const instance = coreHandler.accordionClass.selectInstance(targetInstanceNum);
          instance.menuOpen();
        }
        let targetList = SearchClass.instanceList.filter(v => {
          return v.multipleParent === this.multipleSelector;
        });
        targetList.map(instance => {
          paramHandler.add(instance);
          instance.addFilterEvent(true);
          instance.selected = true;
        });
        this.selected = true;
        this.ele.classList.add("is-selected");
        this.ele.style.opacity = "1";
        this.selected = true;
        this.input.checked = true;
        paramHandler.add(this);
        let accordion = coreHandler.accordionClass.searchAccordion(this.ele);
        accordion.menuOpen();
        if (accordion.depth > 1) {
          let parentAccordion = coreHandler.accordionClass.searchAccordion(accordion.ele);
          parentAccordion.menuOpen();
        }
      } else {
        paramHandler.add(this);
        this.addFilterEvent(true);
        this.selected = true;
        let accordion = coreHandler.accordionClass.searchAccordion(this.ele);
        accordion.menuOpen();
        if (accordion.depth > 1) {
          let parentAccordion = coreHandler.accordionClass.searchAccordion(accordion.ele);
          parentAccordion.menuOpen();
        }

      }

    }

    removeEvent = () => {

      if (this.multipleSelector !== null) {
        const dataBox = this.ele.closest(".js__data-box");
        if (dataBox) {
          const targetInstanceNum = dataBox.getAttribute("data-box-num");
          const instance = coreHandler.accordionClass.selectInstance(targetInstanceNum);
          instance.menuOpen();
        }
        let targetList = SearchClass.instanceList.filter(v => {
          return v.multipleParent === this.multipleSelector;
        });
        targetList.map(instance => {
          instance.removeFilterEvent(true);
          paramHandler.remove(instance);
          instance.selected = false;
        });
        this.ele.classList.remove("is-selected");
        this.ele.style.opacity = "1";
        this.input.checked = false;
        this.selected = false;
        paramHandler.remove(this);
      } else {
        paramHandler.remove(this);
        this.removeFilterEvent(true);
        this.selected = false;

      }

    }
    checkSelectList = () => {
      // console.log(this);
    }

  }

  SearchClass.init();
  // console.log("SearchClass.instanceList" , SearchClass.instanceList );
  return SearchClass;

};